import { MouseEventHandler } from "react";
import Link from "next/link";
import { AnchorTarget } from "@zapier/design-system";
import { cn } from "utils/cn";

type Props = {
  title: string;
  description?: string;
  linkText: string;
  emoji?: string;
  href: string;
  target?: AnchorTarget;
  onClick?: MouseEventHandler<HTMLAnchorElement> | undefined;
};

export function LinksCard({
  title,
  description,
  linkText,
  emoji,
  href,
  target,
  onClick,
}: Props) {
  return (
    <div className="flex min-h-[180px] flex-col rounded-xl bg-zi-white shadow-subtle">
      <div className="flex flex-1 flex-row gap-5 p-5">
        {emoji && (
          <div
            className={cn([
              "h-12 w-12 rounded-lg border bg-zi-white",
              "flex items-center justify-center",
              "text-[26px]",
            ])}
          >
            {emoji}
          </div>
        )}
        <div className="flex flex-1 flex-col gap-2">
          <div className="font-sans text-lg font-semibold">{title}</div>
          {description && (
            <div className="font-sans text-sm leading-[1.6] text-zi-secondaryText">
              {description}
            </div>
          )}
        </div>
      </div>
      <Link
        href={href}
        target={target}
        onClick={onClick}
        className={cn([
          "flex items-center justify-center rounded-b-xl px-4 py-5 text-[17px] font-medium leading-5 text-zi-primary-600",
          "bg-zi-primary-50 transition-colors hover:bg-zi-primary-100",
        ])}
      >
        <span>{linkText} -&gt;</span>
      </Link>
    </div>
  );
}
